import jwt_decode from 'jwt-decode';
import { ITokenInfo } from 'modules/auth/interfaces/token.interfaces';

export const parseToken = (token: string): ITokenInfo => {
  const interimResult: { userData: string } = jwt_decode(token);
  return JSON.parse(interimResult.userData);
};
